import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloDivisaoComercial } from "../models/divisaoComercial";
import { Repositorio } from "./repositorio";

export class RepositorioDivisaoComercial extends Repositorio<ModeloDivisaoComercial> {
  constructor() {
    super(ConstanteGlobal.DIVISAO_COMERCIAL);
  }
}
